import { render, staticRenderFns } from "./ReportMobileReserved.vue?vue&type=template&id=616584ca"
import script from "./ReportMobileReserved.vue?vue&type=script&lang=js"
export * from "./ReportMobileReserved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports